import React from "react";

export default function ExtensionPrivacyCard() {
  return (
    <section className="mt-10 rounded-[2rem] border border-border bg-card p-5 md:p-8">
      <p className="text-xs font-black uppercase tracking-[0.22em] text-primary">Privacy and permissions</p>
      <h2 className="mt-2 text-2xl font-black">Minimum permissions, no hidden install</h2>
      <div className="mt-4 grid gap-4 text-sm leading-7 text-muted-foreground md:grid-cols-2">
        <p>Marstick will use the smallest permission set required, such as storage for preferences, activeTab for user-initiated actions, and notifications only when the user approves them.</p>
        <p>Marstick does not silently install extensions, change browser settings without approval, inject into unrelated websites, or collect browsing history for extension installation.</p>
      </div>
    </section>
  );
}